import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MasterDataService } from '../../services/master-data.service';
import { HumanResourceService } from '../../services/human-resource.service';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-salary-slip-report',
  templateUrl: './salary-slip-report.component.html',
  styleUrls: ['./salary-slip-report.component.css']
})
export class SalarySlipReportComponent implements OnInit {
  selectedBranch;
  isBranchSelected: boolean;
  branchList;
  selectedEmployeeStatus = 1;
  selectedEmployeeName;
  employeeList;
  selectedFinancialYear;
  financialList;
  closingDateList;
  selectedFromClosing;
  selectedToClosing;
  salarySlipReportList = [];
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedEmployeeName = "";
    this.selectedFromClosing = "";
    this.selectedToClosing = "";
    this.showExportToExcelButton = false;
    this.loadInitDetails();
  }

  loadInitDetails() {
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
    this.onBranchSelect();
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }


  onBranchSelect() {
    var branchId = this.selectedBranch.map(({ id }) => id);
    this.masterDataService.getEmployeeByBranch(this.selectedEmployeeStatus, branchId).subscribe((res: any) => {
      console.log('employee list', this.employeeList);
      this.employeeList = res;
    })
  }

  onEmployeeStatusSelect() {
    if (this.selectedEmployeeName != null && this.selectedEmployeeName != '' && this.selectedEmployeeName != undefined) {
      this.onBranchSelect();
    }
  }

  onEmployeeNameSelect() {
    this.selectedFinancialYear = "";
    this.selectedFromClosing = "";
    this.selectedToClosing = "";
    this.salarySlipReportList = [];
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onFinancialYearSelected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          console.log('closing date list', this.closingDateList);
        });
    }
  }

  showExportToExcelButton: boolean;
  onViewReport() {
    console.log('this selectfrom', this.selectedFinancialYear);
    if (this.selectedEmployeeName == undefined || this.selectedEmployeeName == '' || this.selectedEmployeeName == null ||
      this.selectedFinancialYear == undefined || this.selectedFinancialYear == '' || this.selectedFinancialYear == null ||
      this.selectedFromClosing == undefined || this.selectedFromClosing == '' || this.selectedFromClosing == null ||
      this.selectedToClosing == undefined || this.selectedToClosing == '' || this.selectedToClosing == null) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please select all fields.');
      return;
    }
    this.masterDataService.getSalarySlipDetails(this.selectedEmployeeName.id, this.selectedFromClosing.id, this.selectedToClosing.id).subscribe((res: any) => {
      console.log('salary slip report', res);
      if (res.length > 0) {
        this.salarySlipReportList = res;
        this.showExportToExcelButton = true;
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
      }
    })
  }

  onExportToExcelReport() {
    this.masterDataService.getSalarySlipExportToExcel(this.selectedEmployeeName.id, this.selectedFromClosing.id, this.selectedToClosing.id).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "SalarySlipReport.xlsx";
      link.click();
    });
  }

  convertSalarySlipReportIntoPDF() {
    var data = document.getElementById('contentToConvert');
    console.log('data', data, window.screen.width)
    if (this.salarySlipReportList.length <= 4) {
      setWidth = window.screen.width;
    } else {
      var setWidth = this.salarySlipReportList.length * 230;
    }
    html2canvas(data, {
      width: setWidth,
    }).then(canvas => {
      // var imgWidth = 300;
      // var imgHeight = canvas.height * imgWidth / canvas.width;

      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf('l', 'mm', [window.screen.width, window.screen.height]); // A4 size page of PDF
      var width = pdf.internal.pageSize.getWidth();
      // var height = canvas.height * width / canvas.width;
      var height = pdf.internal.pageSize.getHeight();
      pdf.addImage(contentDataURL, 0, 0, width, height);
      pdf.save('SalarySlipReport.pdf'); // Generated PDF
    });
  }
}
